import React, {Component} from 'react';
import {observer} from "mobx-react";
import {checkbox, custom, input} from "../../../utils/linker";
import ImageDrop from "../../Helpers/ImageDrop";

class Gallery extends Component {
  componentDidMount() {
    if(!this.props.linker.value.gallery) {
      this.props.linker.value.gallery=[];
    }
  }

  render() {
    if(!this.props.linker.value.gallery) {
      return null;
    }
    return (
      <div className="padd20 bg-w2 pr rad4 mbottom10">
        <div className="pa pa-tr mdi mdi-close sc1 fs24 lh10 pointer" onClick={()=>{ this.props.deleteMe(); }}></div>
        <ImageDrop aspect="700x100" {...custom(this.props.linker.value,'gallery')} multiple={true}  />
        <div className="ptop5">
          <label>
            <input type="checkbox" value="1" {...checkbox(this.props.linker.value,"spoiler")} /><span className="vam"></span> <span className="dib vam">Есть спойлеры</span>
          </label>
        </div>
      </div>
    )
  }
}

export default observer(Gallery);